/** A function that does nothing. */
export function noop() {
	return;
}
